export
const name: string = "LogDepth";

export
const preproc: string = `
    #ifdef WEBGL2
    #else
    #extension GL_EXT_frag_depth : enable
    #endif
`;

export
const declaration: string = `
    uniform float       u_log_depth_buf_FC;
`;

export
const varyings: string = `
    varying highp float vFragDepth;
`;

export
const implementation: string = `
    void resolveLogarithmicDepth()
    {
        if (u_log_depth_buf_FC > 0.0) {

            #ifdef WEBGL2

             gl_FragDepth  = log2(vFragDepth) * u_log_depth_buf_FC * 0.5;

            #else

            gl_FragDepthEXT = log2(vFragDepth) * u_log_depth_buf_FC * 0.5;

            #endif
        }
        else {
            #ifdef WEBGL2

            gl_FragDepth = gl_FragCoord.z;

            #else

            gl_FragDepthEXT = gl_FragCoord.z;

            #endif
        }
    }
`;
